module.exports = __webpack_public_path__ + "img/11.54a20b08.png";